<template>
  <div
    v-if="show"
    class="menu-form"
    :style="themeStyle"
  >
    <b-card
      no-body
      class="sda-form-card"
    >
      <div class="card-img">
        <div class="popup-close">
          <div
            v-if="canClose"
            class="cursor-pointer card-header-close"
            @click="setAdCookie"
          >
            <div class="line" />
            <div class="line" />
          </div>

          <div
            v-else
            class="card-header-time"
          >
            <div class="time">
              <div class="dot" />
              <svg>
                <circle
                  cx="20"
                  cy="20"
                  r="20"
                />
                <circle
                  ref="counter"
                  cx="20"
                  cy="20"
                  r="20"
                />
              </svg>
              <div class="second">
                {{ closeTime }}
              </div>
            </div>
          </div>
        </div>
        <a
          v-if="configData.url"
          :href="configData.url"
          class="pop-up"
        >
          <picture v-if="configData.image">
            <source
              :srcset="`${baseUrl}${webpImage(configData.image)}`"
              type="image/webp"
            >
            <b-img
              :src="`${baseUrl}${configData.image}`"
              :alt="configData.alt"
              fluid-grow
            />
          </picture>
          <template-empty-area
            v-else
            area-name="彈窗廣告"
          />
        </a>
        <div
          v-else
          class="pop-up"
        >
          <picture v-if="configData.image">
            <source
              :srcset="`${baseUrl}${webpImage(configData.image)}`"
              type="image/webp"
            >
            <b-img
              :src="`${baseUrl}${configData.image}`"
              :alt="configData.alt"
              fluid-grow
            />
          </picture>
          <template-empty-area
            v-else
            area-name="彈窗廣告"
          />
        </div>
        <div class="popup-close-today">
          <b-form-checkbox
            id="close-today"
            v-model="closeToday"
            name="close-today"
          >
            今日不再出現
          </b-form-checkbox>
        </div>
      </div>

      <!-- <b-card-body class="card-content">
      </b-card-body> -->
    </b-card>
  </div>
</template>

<script>
// import useAppConfig from '@core/app-config/useAppConfig'
// import { computed } from '@vue/composition-api' // , onUnmounted
import {
  BCard, VBTooltip, BImg, BFormCheckbox, // BCardBody, BCardHeader,
} from 'bootstrap-vue'

import TemplateEmptyArea from './TemplateEmptyArea.vue'

export default {
  name: 'VerticalNavMenuForm',
  components: {
    BImg,
    BCard,
    BFormCheckbox,
    // BCardHeader,
    // BCardBody,
    TemplateEmptyArea,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    configData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      timer: null,
      closeTime: 0,
      canClose: false,
      themeStyle: null,
      closeToday: false,
    }
  },
  computed: {
    baseUrl() {
      return this.$store.state.api.baseUrl
    },
  },
  mounted() {
    if (this.configData.show) {
      if (this.checkCookie()) return
      this.show = true
      this.canClose = false
      this.closeTime = this.configData.second
      this.themeStyle = {
        backgroundColor: this.configData.background.color,
        backdropFilter: `blur(${this.configData.background.blur})`,
      }
      this.timer = setInterval(() => {
        if (this.closeTime === 0) {
          clearInterval(this.timer)
          this.canClose = true
        }
        this.closeTime -= 1
        this.$refs.counter.style.strokeDashoffset = 125 - (125 * this.closeTime) / this.configData.second
      }, 1000)
    }
  },

  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      return webpSrc
    },
    checkCookie() {
      const cookies = document.cookie.split(';')
      const result = cookies.some(cookie => {
        const [cookieName] = cookie.trim().split('=')
        if (cookieName === 'GameHost-forum') {
          return true
        }
        return false
      })
      return result
    },
    setAdCookie() {
      const now = new Date()
      const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
      this.show = false
      if (this.closeToday) {
        const expires = `expires= ${endOfDay.toUTCString()}`
        document.cookie = `GameHost-forum=; ${expires}`
      } else {
        if (this.configData.replay) return
        const expirationDate = new Date(now.getTime() + 60 * 60 * 1000)
        const expires = `expires= ${expirationDate.toUTCString()}`
        document.cookie = `GameHost-forum=; ${expires}`
      }
    },
  },
  setup() {
    // const { skin } = useAppConfig()
    // const isDark = computed(() => skin.value === 'dark')

    // return {
    //   isDark,
    // }
  },
}
</script>

<style lang="scss">
.pop-up {
  width: 100%;
  .empty-area {
    min-width: 500px;
    @media screen and (max-width: 767px) {
      min-width: 400px;
    }
    @media screen and (max-width: 575px) {
      min-width: 50vw;
    }
  }
}
</style>
<style lang="scss" scoped>
.menu-form {
  // pointer-events: none;
  position: absolute;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  height: 100%;
  width: 100vw;
  z-index: 1033;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sda-form-card{
  position: relative;
  // width: 100%;
  max-width: 80%; // 600px
  max-height: 100%;
  min-height: 200px;
  margin: 10px;
  .popup-close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    display: flex;
    justify-items: space-between;
    align-items: center;
    padding: 15px;
    .card-header-close {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      width: 40px;
      cursor: pointer;
      .line {
        height: 2px;
        width: 20px;
        border-radius: 2px;
        position: absolute;
        background: #7e7d7d;
        transition: all .2s ease-in;
      }
      .line:first-child {
        transform: rotate(45deg);
      }
      .line:last-child {
        transform: rotate(-45deg);
      }
      &:hover {
        .line:first-child {
          transform: rotate(-45deg);
        }
        .line:last-child {
          transform: rotate(45deg);
        }
      }
    }

    .card-header-time {
      .time {
        position: relative;
        width: 50px;
        height: 50px;
      }
      .dot {
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        z-index: 10;
        &:before {
          content: '';
          position: absolute;
          top: 0;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #ffffff;
          box-shadow: 0 0 20px #ffffff,
          0 0 60px #ffffff;
        }
      }
      svg {
        position: relative;
        width: 50px;
        height: 50px;
        transform: rotate(270deg);
      }
      svg circle {
        position: relative;
        width: 100%;
        height: 100%;
        fill: transparent;
        stroke-width: 4;
        stroke: #353535;
        transform: translate(5px, 5px);
      }
      svg circle:nth-child(2) {
        stroke: #fff;
        stroke-width: 5;
        stroke-dasharray: 125;
      }
      .second {
        position: absolute;
        top: 50%;
        left: 50%;
        font-size: 20px;
        font-weight: 600;
        transform: translate(-50%, -50%);
      }
    }
  }
  .popup-close-today {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 1;
  }

  .card-img {
    padding: 10px;
    // margin-bottom: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .card-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
